import { OtpModalActionType } from '../actiontype/otp-modal.actiontype';

export const setOtpFormValidated = otp => dispatch => {
    dispatch(setEnteredOtp(otp.value));
    dispatch(otpFormValidated(otp));
};

export const enableOtpSection = () => {
    return { type: OtpModalActionType.ENABLE_OTP_SECTION }
}

function otpFormValidated(otp){ return { type: OtpModalActionType.OTP_FORM_VALIDATED, payload: otp.valid }};
function setEnteredOtp(value){ return { type: OtpModalActionType.ENTERED_OTP, payload: value }};